import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from 'app/auth/service';

@Injectable({
  providedIn: 'root'
})
export class WalletGuard implements CanActivate {
  /**
   *
   * @param {Router} _router
   * @param {AuthenticationService} _authenticationService
   */
   constructor(private _router: Router, private _authenticationService: AuthenticationService) {}

   // canActivate
   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
     const currentUser: any = this._authenticationService.currentUserValue;
     if(currentUser && currentUser.user){
       return true;
     }
 
     // not logged in so redirect to login page with the return url
     this._router.navigate(['/']);
     return false;
   }
  
}
